import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import authReducer from "./auth/slice";
import authSaga from "./auth/saga";
import postsSaga from "../redux/PostAuth/saga";
import postsReducer from "./PostAuth/slice";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    auth: authReducer,
    posts: postsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        ignoredActions: ["auth/loginUser"],
        ignoredActionPaths: ["payload.navigate", "meta.arg.navigate"],
      },
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(authSaga);
sagaMiddleware.run(postsSaga);
